export const required = (v: string) => (!!v || v == String(false)) || 'Campo obrigatório'
